import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/studio/components/Slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/studio/components/ValuesBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/ophirstudio_next/app/[lang]/studio/components/Workflow.tsx");
;
import(/* webpackMode: "eager" */ "/root/ophirstudio_next/node_modules/next/dist/client/link.js");
